// eslint-disable-next-line import/no-anonymous-default-export
export default {
    api: 'https://dev.adminapi.pikkle.me',
    title: 'PIKKLE',
    defaultPath: [{ role: 'SUPER_ADMIN', url: '/main/info' }],
    basename: '/bundong',
};
